import { FahrradWert, Produktlinienname, TaasTarifrisikoschluesselVHVV2, VorvertragBaustein } from '@ps20/bff-models';
import { TaasTarifrisikoschluessel } from '@ps20-frontend/frontend-models';

export const ZUSATZOPTION_FAHRRAD_ID = 'diebstahlVonFahrradUndFortbewegungsmitteln';
export const ZUSATZOPTION_FAHRRAD_KASKO_ID = 'vollkaskoAlleFahrraeder';

export const isFahrradBaustein = (
  baustein: VorvertragBaustein<TaasTarifrisikoschluessel> | undefined | null,
): boolean =>
  baustein?.taasTarifrisikoschluessel === TaasTarifrisikoschluesselVHVV2.FAHRRAD ||
  baustein?.taasTarifrisikoschluessel === TaasTarifrisikoschluesselVHVV2.FAHRRAD_KASKO;

export interface FahradwertForLinie {
  produktlinie: Produktlinienname;
  summe: FahrradWert;
}
